// Site Content - Easy to edit content sections
// Simply modify the text below to update your website

export const siteContent = {
  // Business Information
  business: {
    name: "ZAZ Precision Auto Detailing",
    tagline: "Professional mobile car detailing services that bring showroom quality results directly to your driveway",
    phone: "(973) 534-0023",
    email: "zazprecisionautodetailingllc@gmail.com",
    serviceArea: "Mobile Service - I come to your location",
  },

  // Hero Section
  hero: {
    title: "ZAZ PRECISION",
    subtitle: "AUTO DETAILING",
    description: "Professional mobile car detailing services that bring showroom quality results directly to your driveway",
    features: ["Mobile Service", "Paint Protection", "Steam Extraction"],
    ctaPrimary: "Get Free Quote",
    ctaSecondary: "View Services",
  },

  // Feature Cards (below hero)
  featureCards: [
    {
      icon: "truck",
      title: "Mobile Convenience",
      description: "I come to you! Only need access to water and electricity at your location.",
    },
    {
      icon: "shield",
      title: "Paint Correction",
      description: "Professional paint correction and enhancement services that restore your vehicle's shine.",
    },
    {
      icon: "sparkles",
      title: "Complete Detailing",
      description: "Full interior and exterior detailing plus headlight restoration for a complete transformation.",
    },
  ],

  // Services Section
  services: {
    title: "My Premium Services",
    subtitle: "Professional mobile auto detailing services delivered with precision and care. I bring showroom-quality results directly to your location.",
    items: [
      {
        name: "Reset Detail",
        isPremium: true,
        description: "My ultimate comprehensive detailing package that completely transforms your vehicle inside and out.",
        features: [
          "Complete interior blow out and vacuum",
          "Steam extraction of upholstery and carpets",
          "Interior deodorizing and leather conditioning",
          "Paint clay bar treatment and machine polishing",
          "Premium paint sealant (up to 8 months protection)",
          "Wheels, tires, and door jambs detailed",
        ],
      },
      {
        name: "Full Interior & Exterior Detailing",
        isPremium: false,
        description: "Complete comprehensive cleaning and restoration of your vehicle inside and out.",
        features: [
          "Deep interior cleaning and conditioning",
          "Exterior wash and paint sealing application",
          "Leather cleaning and conditioning",
          "Deep interior steam cleaning and extraction",
          "Glass cleaning",
        ],
      },
      {
        name: "Paint Correction",
        isPremium: false,
        description: "Professional paint restoration to remove swirl marks, scratches, and imperfections.",
        features: [
          "Multi-stage paint correction process",
          "Swirl mark and scratch removal or reduction",
          "High-quality finishing compounds",
        ],
      },
      {
        name: "Paint Enhancement",
        isPremium: false,
        description: "Restore shine, improve gloss, and remove light swirl marks using professional polishing techniques and high-quality detailing products.",
        features: [
          "Restoring shine and clarity",
          "Improving gloss and depth",
          "Light swirl mark removal",
          "High-quality detailing products",
          "Long-lasting protection",
        ],
      },
      {
        name: "Headlight Restoration",
        isPremium: false,
        description: "Restore oxidized and cloudy headlights for improved clarity, visibility, and safety.",
        features: [
          "UV damage restoration",
          "Oxidation removal",
          "Clarity enhancement",
          "Protective sealant application",
          "Improved visibility and safety",
        ],
      },
    ],
  },

  // Mobile Service Banner
  mobileBanner: {
    title: "100% Mobile Service",
    description: "I come to your location! All I need is access to a water spigot and electricity, and I'll handle the rest.",
    ctaText: "Schedule Your Service",
  },

  // Gallery/Results Section
  gallery: {
    title: "My Results",
    subtitle: "See the incredible transformations I achieve through my precision auto detailing services. Quality speaks for itself.",
    images: [
      {
        src: "https://customer-assets.emergentagent.com/job_car-spa-pro-1/artifacts/ye68oxte_dtp5.jpg",
        alt: "Blue Ford Mustang after professional paint correction",
        title: "Blue Mustang - Before & After",
        description: "Complete paint correction and enhancement on this beautiful blue Mustang",
      },
      {
        src: "https://customer-assets.emergentagent.com/job_car-spa-pro-1/artifacts/9yb5mp0v_dtp6.jpg",
        alt: "Black luxury SUV after comprehensive exterior detailing",
        title: "Luxury SUV - Paint Perfection",
        description: "Full exterior detailing with paint correction on this premium SUV",
      },
      {
        src: "https://customer-assets.emergentagent.com/job_car-spa-pro-1/artifacts/9bo97esu_dtp8.jpg",
        alt: "Luxury vehicle interior showing professional deep cleaning",
        title: "Interior Deep Clean",
        description: "Professional interior detailing showcasing my attention to detail",
      },
      {
        src: "https://customer-assets.emergentagent.com/job_car-spa-pro-1/artifacts/wha5fb9c_dtp2.jpg",
        alt: "Silver convertible after Reset Detail premium package",
        title: "Convertible Restoration",
        description: "Complete paint enhancement and detailing on this stylish convertible",
      },
      {
        src: "https://customer-assets.emergentagent.com/job_car-spa-pro-1/artifacts/o1zmh9gc_dt4.jpg",
        alt: "Dark SUV showcasing professional paint correction",
        title: "SUV Paint Correction",
        description: "Professional paint correction and protection applied to this SUV",
      },
    ],
  },

  // About Section
  about: {
    title: "About ZAZ Precision",
    subtitle: "Professional mobile auto detailing services that bring convenience and quality directly to you.",
    mainHeading: "Premium Mobile Auto Detailing",
    description: [
      "At ZAZ Precision Auto Detailing, I specialize in bringing professional-grade auto detailing services directly to your doorstep. My mobile approach means you never have to leave the comfort of your home or office.",
      "I pride myself on delivering comprehensive interior and exterior detailing, expert paint correction, paint enhancement, and headlight restoration services that exceed expectations.",
      "All I need is access to water and electricity - I handle everything else! My professional equipment and premium products ensure your vehicle receives the care it deserves.",
    ],
    features: [
      {
        icon: "zap",
        title: "Simple Requirements",
        description: "Just provide access to a water spigot and electrical outlet - I bring all the professional equipment and supplies needed for a complete detailing service.",
        highlighted: true,
      },
      {
        icon: "truck",
        title: "100% Mobile Service",
        description: "I bring my professional detailing services directly to your location - home, office, or anywhere convenient for you.",
      },
      {
        icon: "calendar",
        title: "Flexible Scheduling",
        description: "Book appointments that work with your schedule. I offer flexible timing to accommodate your busy lifestyle.",
      },
      {
        icon: "award",
        title: "Professional Quality",
        description: "Using only premium products and proven techniques to deliver showroom-quality results every time.",
      },
      {
        icon: "heart",
        title: "Customer Focused",
        description: "Your satisfaction is my priority. I treat every vehicle with the care and attention it deserves.",
      },
    ],
    specializedServices: [
      "Full Interior & Exterior Detailing",
      "Paint Correction",
      "Paint Enhancement",
      "Headlight Restoration",
    ],
  },

  // Quote Section
  quote: {
    title: "Get Your Free Quote",
    subtitle: "Tell me about your vehicle and the services you need. I'll provide you with a detailed quote within 24 hours.",
    // GoHighLevel Form Embed URL - Replace this with your actual GoHighLevel form URL
    goHighLevelFormUrl: "https://api.leadconnectorhq.com/widget/form/h4f6WzsFMMODF5Tmp2oh",
  },

  // Contact Section
  contact: {
    title: "Contact Me",
    subtitle: "Ready to experience professional mobile auto detailing? Get in touch today to schedule your service or ask any questions.",
    info: [
      {
        icon: "phone",
        title: "Phone",
        value: "(973) 534-0023",
        description: "Call or text anytime",
      },
      {
        icon: "mail",
        title: "Email",
        value: "zazprecisionautodetailingllc@gmail.com",
        description: "I respond within 24 hours",
      },
      {
        icon: "mapPin",
        title: "Service Area",
        value: "Mobile Service",
        description: "I come to your location",
      },
      {
        icon: "clock",
        title: "Availability",
        value: "Flexible Scheduling",
        description: "Book appointments that fit your schedule",
      },
    ],
    cta: {
      title: "Ready to Transform Your Vehicle?",
      description: "Experience the convenience of professional mobile auto detailing. I bring all the equipment and expertise needed to make your vehicle look its absolute best.",
      note: "Simple Requirements: Just water spigot access and electrical outlet - I handle everything else!",
    },
    benefits: [
      "I come to you",
      "Professional equipment",
      "Premium products",
      "Flexible scheduling",
    ],
  },

  // Footer
  footer: {
    copyright: `© ${new Date().getFullYear()} ZAZ Precision Auto Detailing LLC. All rights reserved.`,
    tagline: "Professional Mobile Auto Detailing",
  },
};
